import { TCorrelationValue } from '../types';

export const transformChartData = (
  data: number | null | undefined,
  xAxisValue: number,
  sampleCode: string,
  enabled: boolean,
  color?: string,
  poro?: number,
  metadata?: {
    source?: TCorrelationValue['source'];
    comparisonRole?: TCorrelationValue['comparisonRole'];
  },
  phiz?: number,
  rqi?: number,
  symbol?: string,
  analysisTypes?: string[]
): TCorrelationValue => {
  return {
    x: poro ? Number(poro.toFixed(4)) : Number(xAxisValue.toFixed(4)),
    y: Number(data || 0),
    name: sampleCode,
    xAxisValue: xAxisValue,
    phiz,
    rqi,
    color: color,
    source: metadata?.source,
    comparisonRole: metadata?.comparisonRole,
    enabled,
    analysisTypes,
    marker: {
      radius: enabled ? 5.5 : 4.5,
      symbol,
    }
  };
};
